import { EngineStoreData } from "@/stores/EngineStore/EngineStore.ts";

export const setDateRangeHelper = (
  state: EngineStoreData,
  itemId: string,
  dateRange: [Date | null, Date | null],
) => {
  const newItems = state.cartAccommodationItems?.map((item) => {
    if (item.id === itemId) {
      return { ...item, dateRange };
    }
    return item;
  });
  return { cartAccommodationItems: newItems };
};
